/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Karol Pawlak <kpa@giap.pl>, October 2020
 */

/* eslint-disable max-len */
/* flow-disable */

import React, { PropTypes } from 'react';
import _ from 'lodash';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { connect } from 'react-redux';
import { runService } from '../../actions/eservices';
import PowrotDoListyEuslug from '../../components/PowrotDoListyEuslug/PowrotDoListyEuslug';
import EmptyFileDownloader from '../../components/EmptyFileDownloader/EmptyFileDownloader';
import { DecisionContainer, PersonalDataContainer } from '../../containers';
import AttachmentsPanel from '../../components/AttachmentsPanel/AttachmentsPanel';
import GrayPanel from '../../components/GrayPanel/GrayPanel';
import CustomizedMap from './CustomizedMap';
import history from '../../core/history';
import pans from './panStyle.scss';
import ModalAlert from './ModalAlert';
import v from './validators';
import agentConfig from './agent';
import loadingData from './loading';


const btnStyle = {
  borderRadius: 0,
  border: 'none',
  padding: '10px 40px',
  marginLeft: '10px',
};

const decisionOptions = [
  {
    label: 'o warunkach zabudowy',
    value: 'warunkach zabudowy',
    state: 'decisionType',
  },
  {
    label: 'o lokalizacji inwestycji celu publicznego',
    value: 'lokalizacji inwestycji celu publicznego',
    state: 'decisionType',
  },
];

const agentDict = {
  agentName: {
    label: 'Imię i nazwisko/Nazwa:',
    editable: true,
  },
};

const changeDict = {
  decisionType: {
    label: 'Rodzaj decyzji',
    editable: true,
    type: 'Select',
    options: decisionOptions,
  },
  NrDecyzji: {
    label: 'Nr decyzji',
    editable: true,
  },
  data: {
    label: 'Data decyzji',
    editable: true,
  },
  organ: {
    label: 'Organ wydający decyzję',
    editable: true,
    type: 'textarea',
  },
  nazwa: {
    label: 'Opis przedsięwzięcia',
    editable: true,
    type: 'textarea',
  },
  miejscowosc: {
    label: 'Miejscowość',
    editable: true,
    type: 'textarea',
  },
  zmiana: {
    label: 'Zmiana w zakresie (opisać)',
    editable: true,
    type: 'textarea',
  },
  uzasadnienie: {
    label: 'Uzasadnienie zmiany',
    editable: true,
    type: 'textarea',
  },
};


class ZmianaWZULICP extends React.Component {
  state = {
    info: {
      decisionType: null,
      NrDecyzji: null,
      data: null,
      organ: null,
      nazwa: null,
      miejscowosc: null,
      zmiana: null,
      uzasadnienie: null,
      agentAdd: 'NIE',
      agentName: null,
    },
    selectedParcels: [],
    selectedRoads: [],
    errors: {},
    errorTitle: '',
    errorText: '',
    showError: false,
    attachments: null,
    eserviceDistrict: null,
    loading: false,
  };

  validators = {
    decisionType: [v.NotSelected],
    NrDecyzji: [v.NotNull],
    data: [v.NotNull],
    organ: [v.NotNull],
    nazwa: [v.NotNull],
    miejscowosc: [v.NotNull],
    zmiana: [v.NotNull],
    uzasadnienie: [v.NotNull],
    agentName: [],
  };

  nextStep = '/eservices/eserviceSummary/';

  onHide = () => this.setState({ showError: false });

  componentDidMount() {
    fetch(`${process.env.API_URL}/eservice/${this.props.district}/${this.props.query.serviceType}`)
      .then(r => r.json())
      .then(resp => {
        this.setState({
          eserviceDistrict: resp,
        });
      });
  }

  setParcels = (parcels, callback = null) => this.setState({ selectedParcels: parcels });
  setRoads = (roads, callback = null) => this.setState({ selectedRoads: roads });


  onChange = (e, group) => {
    const name = e.target.name;
    this.setState(
      {
        [group]: {
          ...this.state[group],
          [name]: e.target.value,
        },
      },
      () => this.validate(group, name),
    );
  };

  onChangeSelect = (e, group) => {
    const name = e.state;
    this.setState(
      {
        [group]: {
          ...this.state[group],
          [name]: e.value,
        },
      },
      () => this.validate(group, name),
    );
    if (name === 'agentAdd') {
      this.onChangeAgent(e.value);
    }
  }

  onChangeAgent = (value) => {
    if (value === 'TAK') {
      this.validators.agentName = [v.NotNull];
    } else {
      this.validators.agentName = [];
    }
  }

  validateField = (group, field) => {
    const checks = [];
    if (Object.keys(this.validators).indexOf(field) > -1) {
      for (const validator of this.validators[field]) {
        const check = validator(this.state[group][field]);
        if (check) checks.push(check);
      }
    }
    return checks;
  };

  validateGroup = group => {
    const fields = Object.keys(this.state[group]);
    const errors = {};
    for (const f of fields) {
      const checks = this.validateField(group, f);
      errors[f] = checks;
    }
    return errors;
  };

  validate = (group, field = null, callback = null) => {
    let newState = null;
    if (field) {
      if (Object.keys(this.validators).indexOf(field) > -1) {
        const checks = this.validateField(group, field);
        newState = {
          errors: {
            ...this.state.errors,
            [field]: checks,
          },
        };
      }
    } else if (group) {
      const errors = this.validateGroup(group);
      newState = { errors };
    } else {
      let errors = {};
      const grupy = ['info'];
      for (const g of grupy) {
        const err = this.validateGroup(g);
        errors = { ...errors, ...err };
      }
      newState = { errors: { ...errors } };
    }
    if (newState) {
      if (callback) {
        this.setState(newState, callback);
      } else {
        this.setState(newState);
      }
    }
  };

  validateAttachmentsContent = () => {
    for (const attachment of this.state.attachments) {
      if (attachment.name.length < 1) return true;
    }
    return false;
  }

  haseErrors = () => {
    for (const key of Object.keys(this.state.errors)) {
      if (this.state.errors[key].length > 0) return true;
    }
    return false;
  };

  onChangeAttachments = (attachments, errorMessage) => {
    const errorText = errorMessage.errorText;
    const errorTitle = errorMessage.errorTitle;
    const showError = errorMessage.showError;
    this.setState({ attachments, errorText, errorTitle, showError });
  }

  insertTestData = () => {
    this.setState({
      info: {
        decisionType: 'warunkach zabudowy',
        NrDecyzji: 'WZ0080',
        data: '10.10.2020',
        organ: 'Organ testowy',
        nazwa: 'Opis testowy',
        miejscowosc: 'Warszawa',
        zmiana: 'zmiana test',
        agentAdd: 'TAK',
        agentName: 'Jan Kowalski',
        uzasadnienie: 'uzasadnienie TEST',
      },
    });
  };

  postValidation = () => {
    const hasFieldErrors = this.haseErrors();
    if (this.state.selectedParcels.length === 0) {
      this.setState({
        errorText: 'Nie wybrano działki ewidencyjnej. Prosimy o wskazanie działki',
        errorTitle: 'Błędnie wypełniony formularz',
        showError: true,
        loading: false,
      });

      return;
    }

    if (hasFieldErrors) {
      this.setState({
        errorText: 'Uzupełnij pola obowiązkowe.',
        errorTitle: 'Błędnie wypełniony formularz.',
        showError: true,
        loading: false,
      });
      return;
    }

    if (!this.state.attachments || this.state.attachments.length === 0) {
      this.setState({
        errorText: 'Wymagane jest dodanie załączników do składanego wniosku',
        errorTitle: 'Brak załączników.',
        showError: true,
        loading: false,
      });
      return;
    }

    const hasEmptyAttachment = this.validateAttachmentsContent();
    if (hasEmptyAttachment) {
      this.setState({
        errorText: 'Przynajmniej jeden załącznik jest pusty. Dodaj plik do załączników',
        errorTitle: 'Pusty załącznik.',
        showError: true,
        loading: false,
      });
      return;
    }

    if (!hasFieldErrors && this.state.selectedParcels.length > 0) {
      this.props
        .runService(this.props.serviceInfo.eservice.shortName, this.props.district, {
          info: { ...this.state.info },
          dzialki: this.state.selectedParcels,
          user: {
            ...this.props.serviceInfo.user,
          },
          selectedParcels: this.state.selectedParcels,
          shortName: this.props.serviceInfo.eservice.shortName,
          urzad: this.props.districts[this.props.prefix],
          attachments: this.state.attachments,
        })
        .then(resp => {
          this.redirectToSummary(resp.jobId);
        });
    }
  };

  redirectToSummary = (jobId) => {
    window.location.href = `${this.nextStep}${jobId}`;
  };

  startService = () => {
    this.validate(null, null, this.postValidation);
  };

  render() {
    return (
      <div style={{ paddingTop: '20px' }}>
        <h3 style={{ textAlign: 'center' }}>
          {this.props.serviceInfo.eservice.title}
        </h3>
        <PersonalDataContainer userData={this.props.serviceInfo.user} />
        <GrayPanel
          title={'1. Teren'}
        >
          <div className="help-desc">
            W celu wybrania przedmiotowej działki lub działek ewidencyjnych należy wykorzystać jeden z dwóch dostępnych sposobów wyboru działki:<br />
            <ol>
              <li> Wybrać obręb ewidencyjny z rozwijalnej listy obrębów, a następnie wpisać numer działki. W celu dodania kolejnej działki należy powtórzyć czynność.</li>
              <li>Wskazać działkę w oknie mapy wykorzystując przycisk <samp>"Wskaż działki na mapie"</samp>. W celu wybrania kilku działek konieczne jest przytrzymanie na klawiaturze klawisza <kbd>CTRL</kbd>.</li>
            </ol>
            Wybór działek można usunąć pojedynczo lub usuwając wszystkie za pomocą przycisku <samp>"Odznacz wszystko"</samp>.
          </div>
          <CustomizedMap
            serviceType={this.props.serviceInfo.eservice.shortName}
            setParcels={this.setParcels}
            setSelectDzialki={this.setSelectDzialki}
            selectedParcels={this.state.selectedParcels}
            obreby={this.props.serviceInfo.precints}
            district={this.props.districts[this.props.prefix]}
            prefix={this.props.prefix}
            mapState={this.props.mapstates[0]}
            settings={this.props.serviceInfo.eservice.mapConfig}
            dokumentType={this.props.serviceInfo.eservice}
          />
        </GrayPanel>
        {this.state.eserviceDistrict && this.state.eserviceDistrict.enableAgent ?
          <DecisionContainer
            title={'Pełnomocnik'}
            data={this.state.info}
            errors={this.state.errors}
            formDict={agentConfig.agentInfoDict}
            onChange={e => this.onChange(e, 'info')}
            onChangeSelect={e => this.onChangeSelect(e, 'info')}
          >
            <br />
          </DecisionContainer>
          : null }
        {this.state.info.agentAdd === 'TAK' ?
          <DecisionContainer
            title={'Dane identyfikacyjne pełnomocnika'}
            data={this.state.info}
            errors={this.state.errors}
            formDict={agentDict}
            onChange={e => this.onChange(e, 'info')}
          /> : null }
        <DecisionContainer
          title={'2. Informacje'}
          data={this.state.info}
          errors={this.state.errors}
          formDict={changeDict}
          onChange={e => this.onChange(e, 'info')}
          onChangeSelect={e => this.onChangeSelect(e, 'info')}
        />

        <GrayPanel title={"Informacja dla wnioskodawcy"}>
          <div className="row">
            <div className="col-sm-12">
              <p><b>Do niniejszego wniosku należy dołączyć załączniki:</b></p>
              <p>1. Dowód uiszczenia opłaty skarbowej w wysokości:</p>
              <p>598 zł – za wydanie zmiany decyzji.</p>
              <p>UWAGA: Nie podlega opłacie skarbowej wydanie decyzji na wniosek właściciela lub użytkownika wieczystego terenu, którego wniosek dotyczy.</p>
              <p>17 zł - za dokument stwierdzający udzielenie pełnomocnictw.</p>
            </div>
          </div>
        </GrayPanel>

        <AttachmentsPanel onChangeAttachments={this.onChangeAttachments} />

        <ModalAlert
          title={this.state.errorTitle}
          bodyText={this.state.errorText}
          show={this.state.showError}
          name="errorModal"
          onHide={this.onHide}
        />
        <ModalAlert
          title={loadingData.loadingTitle}
          bodyText={loadingData.loadingBody}
          show={this.state.loading}
          name="loadingModal"
          onHide={this.onHide}
          disableButton
        />

        {/* BUTTONS */}
        <div className="row mobile-row">
          <div className="col-sm-12">
            <PowrotDoListyEuslug position="left" prefix={this.props.prefix} />
            <EmptyFileDownloader position="left" prefix={this.props.prefix} serviceType={this.props.serviceInfo.eservice.shortName} />
            <button
              type="submit-lg"
              className={this.props.isDisabled ? 'btn btn-primary disabled' : 'btn btn-primary'}
              style={{ float: 'right', marginRight: '15px', ...btnStyle }}
              onClick={() => this.setState({ loading: true }, () => this.startService())}
            >
              Uruchom
            </button>
            {_.includes(this.props.serviceInfo.user.roles, 'superadmin') ? (
              <button
                type="submit-lg"
                className="btn btn-success"
                style={{ float: 'right', marginRight: '15px', ...btnStyle }}
                onClick={this.insertTestData}
              >
                Insert Test Data
              </button>
            ) : null}
            <button
              type="submit-lg"
              className="btn btn-default"
              style={{ float: 'right', marginRight: '15px', ...btnStyle }}
              onClick={history.goBack}
            >
              Anuluj
            </button>
          </div>
        </div>
      </div>
    );
  }
}

ZmianaWZULICP.propTypes = {
  serviceInfo: PropTypes.object,
  district: PropTypes.object,
};

const mapState = state => ({
  current_service: state.eservices.current,
  districts: state.district.districts
});

const mapDispatch = {
  runService,
};

export default withStyles(pans)(
  connect(
    mapState,
    mapDispatch,
  )(ZmianaWZULICP),
);



// WEBPACK FOOTER //
// src/routes/eservices/ZmianaWZULICP.js